import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function groupTariff() {
    return {
        index,
        get,
        create,
        update,
        remove
    };

    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`grouptariff/search${params}`);
    }

    function get(id) {
        return axiosInstance.get(`grouptariff/get?id=${id}`);
    }

    function create(data) {
        return axiosInstance.post('grouptariff/create', data);
    }

    function update(data) {
        return axiosInstance.patch('grouptariff/update', data);
    }

    function remove(id) {
        return axiosInstance.delete(`grouptariff/delete`, {
            data: {
                id: id
            }
        });
    }
}
